import ko from 'rgs-knockout';
import _ from 'lodash';

const getValue = value => _.isFunction(value) ? value() : value;


//to be continue...
export class FormCreator {

	constructor (options) {
		const {
			fields,
			onSubmit,
			withValidate,
		} = _.defaults({...options}, {
			withValidate: false,
			onSubmit: _.noop,
			fields: null,
		});

		this._withValidate = ko.pureComputed(() => ko.unwrap(withValidate));
		this._fields = fields;
		this._handlers = {
			onSubmit,
		};

		Object.defineProperty(this, 'fields', {
			get: () => fields, //just FormCreatorInstance.fields
		});
	}

	takeValues () {
		const fields = this._fields;

		return _.reduce(fields, (result, value, key) => ({
			...result,
			[key]: getValue(value),
		}), {});
	}

	isValueInvalid (value) {
		if (ko.isObservable(value) && value.isValid) {
			return !value.isValid();
		}

		return false;
	}

	_isFormInvalid () {
		const fields = this._fields;

		return _.some(fields, this.isValueInvalid);
	}

	onSubmit = (...args) => {
		if (this._withValidate() && this._isFormInvalid()) {
			return;
		}

		const virtualFormValues = this.takeValues();

		this._handlers.onSubmit(virtualFormValues, ...args);
	}
}
